import { render, staticRenderFns } from "./UserMenuItem.vue?vue&type=template&id=7a7d9de9&scoped=true&"
import script from "./UserMenuItem.vue?vue&type=script&lang=js&"
export * from "./UserMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./UserMenuItem.vue?vue&type=style&index=0&id=7a7d9de9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a7d9de9",
  null
  
)

export default component.exports